var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.648,
    height: 18.648,
    viewBox: "0 0 18.648 18.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3844467_magnifier_search_zoom_icon",
    "data-name": "3844467_magnifier_search_zoom_icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_42_",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_44_",
    x1: 4.594,
    y1: 4.594,
    transform: "translate(11.64 11.64)",
    fill: "none",
    stroke: "#9f9f9f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e859c234067447dffdcd551ecf4a6bd2.svg";
export { ForwardRef as ReactComponent };